import {
  GetConfigSoftSkillsDimensionsResponse,
  UpdateSoftSkillsDimensionsConfig,
} from "../../../types/api/configurations.type";
import httpClient from "../../client/HttpClient";

const ConfigurationsSoftSkillsDimensionsService = {
  async list(): Promise<GetConfigSoftSkillsDimensionsResponse> {
    const response =
      await httpClient.get<GetConfigSoftSkillsDimensionsResponse>(
        "v1/config/soft-skills/dimensions",
      );
    return response;
  },
  async update(body: UpdateSoftSkillsDimensionsConfig): Promise<void> {
    await httpClient.patch("v1/config/soft-skills/dimensions", body);
  },
};

export default ConfigurationsSoftSkillsDimensionsService;
